module.exports = __webpack_public_path__ + "static/media/PPO.4045e187.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/PPO.png
// module id = 812
// module chunks = 5